/**
 * Shared content-area styles for admin + shop admin pages.
 */
export const pageCardSx = {
  borderRadius: '16px',
  overflow: 'hidden',
  border: 'none',
  boxShadow: '0 1px 2px rgba(22, 25, 22, 0.03)',
  backgroundColor: 'background.paper'
} as const;

export const pageToolbarSx = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
  px: { xs: 1.5, sm: 2.5 },
  py: 1.75,
  backgroundColor: 'background.paper',
  borderBottom: '1px solid',
  borderColor: 'rgba(22, 25, 22, 0.05)'
} as const;

export const pageTitleSx = {
  fontWeight: 700,
  letterSpacing: '-0.025em',
  fontSize: { xs: '1rem', sm: '1.0625rem' },
  m: 0,
  lineHeight: 1.25,
  fontFamily: '"Manrope", "Plus Jakarta Sans", sans-serif'
} as const;

export const pageFilterFieldSx = {
  minWidth: { xs: '100%', sm: 140 },
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    backgroundColor: 'background.paper'
  }
} as const;
